<template>
    <projects :type="type"></projects>
</template>

<script>
    import Projects from '../components/projects/Projects';
    export default {
        name: "FirebaseProjects",
        components: { Projects },
        data() {
            return {
                type: 'firebase',
            }
        }
    }
</script>
